// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"56":"b74b561a","67":"0172808a","108":"6af4a7a1","161":"ea95a2aa","175":"e2db9c04","176":"cb8cc3f0","282":"dea874a8","448":"e9e3ad90","695":"bbd7ecae","771":"75254930","803":"ce988ea9","955":"9b66b53e"}[chunkId] + ".js";
};